export default __webpack_public_path__ + "static/media/engagement1.b934a3c5.jpg";